import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Box } from '@mui/material'

import ImageWithSku from '../ImageWithSku'
import StrapiSliderV2 from '../Slider-v2'
import BlogSection from './BlogSection'
import StrapiImageGallery from '../ImageGallery/ImageGallery'
import StrapiMarkdown from '../Markdown'
import StrapiVideo from '../Video'

import {
  HeadingStyles,
  SubheadingStyles,
  LinkStyles,
  ParagraphWrapper,
  ParagraphMainHeadingStyles,
  ParagraphImageGalleryHeadingStyles,
  ParagraphBodyStyles,
  BlogImageGalleryStyles,
  SliderWrapperStyles,
} from './index.styles'

const Blog = ({ data }) => {
  const {
    testId,
    MainImage,
    Heading,
    SubHeading,
    Link,
    ParagraphHeading,
    ParagraphBody,
    Slider,
    BlogSections,
    ImageGallery,
    ImageGalleryHeading,
  } = data?.Blog || {}
  const markdown = ParagraphBody?.Markdown
  const blogVideo = ParagraphBody?.BlogVideo
  return (
    <div data-testid={testId}>
      {MainImage && <ImageWithSku data={MainImage} />}
      {Heading && <HeadingStyles align="center">{Heading}</HeadingStyles>}
      {SubHeading && <SubheadingStyles align="center">{SubHeading}</SubheadingStyles>}
      {Link && <LinkStyles data={{ ...Link }} />}
      {(ParagraphHeading || ParagraphBody) && (
        <ParagraphWrapper>
          <ParagraphMainHeadingStyles>{ParagraphHeading}</ParagraphMainHeadingStyles>
          <ParagraphBodyStyles>
            <StrapiMarkdown gridWrapper={false} data={markdown} />
          </ParagraphBodyStyles>
        </ParagraphWrapper>
      )}
      {blogVideo && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgb(8, 6, 6)',
            height: '100%',
            width: '100%',
            overflow: 'hidden',
            margin: '50px auto',
            maxWidth: '800px',
            '& .video-box': {
              width: '100%',
            },
          }}
        >
          <StrapiVideo data={{ Video: blogVideo }} videoProps={{ height: 'auto', width: '100%' }} />
        </Box>
      )}
      {Slider && (
        <SliderWrapperStyles>
          <StrapiSliderV2 data={Slider} blogCollection />
        </SliderWrapperStyles>
      )}
      {BlogSections && BlogSections?.map(blogSection => <BlogSection key={blogSection?.testId} data={blogSection} />)}
      {ImageGallery && (
        <BlogImageGalleryStyles>
          {ImageGalleryHeading && (
            <ParagraphImageGalleryHeadingStyles>{ImageGalleryHeading}</ParagraphImageGalleryHeadingStyles>
          )}
          <StrapiImageGallery data={ImageGallery} />
        </BlogImageGalleryStyles>
      )}
    </div>
  )
}

export default Blog

Blog.propTypes = {
  data: PropTypes.object,
}

export const BlogFragment = graphql`
  fragment StrapiPageBlogFragment on StrapiBlog {
    testId
    MainImage {
      ...BaseImageWithSkuFragment
    }
    Heading
    SubHeading
    Link {
      Link {
        ...StrapiLinkFragment
      }
    }
    ParagraphHeading
    ParagraphBody {
      Markdown {
        ...StrapiPageMarkdownFragment
      }
      BlogVideo {
        ...StrapiPageVideoFragment
      }
    }
    Slider {
      Slider {
        ...StrapiSliderfragment
      }
    }
    BlogSections {
      ...BlogSectionFragment
    }
    ImageGallery {
      ImageGallery {
        ...ImageGalleryFragment
      }
    }
    ImageGalleryHeading
  }
`
